import { call } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import qs from "qs";
import ugcRequest from "@util/net/ugc";
import {
  StyleHintAllStylingInfo,
  LargeStyleHintAllStylingPayload,
  LargeOfficialAllStylingPayload,
  LargeStyleHintAllStylingResponse,
  OfficialAllStylingInfo,
  LargeOfficialAllStylingResponse
} from "@type/index";

export function* loadStyleHintAllStylingSaga(
  payload: LargeStyleHintAllStylingPayload
): Generator<
  any,
  StyleHintAllStylingInfo | undefined,
  AxiosResponse<LargeStyleHintAllStylingResponse>
> {
  try {
    const response = yield call(ugcRequest.get, "/all-styling", {
      params: { ...payload },
      paramsSerializer: function (params: LargeStyleHintAllStylingPayload) {
        return qs.stringify(params, { arrayFormat: "indices" });
      }
    });
    return response.data.stylings[0];
  } catch (error) {
    return undefined;
  }
}

export function* loadOfficialAllStylingSaga(
  payload: LargeOfficialAllStylingPayload
): Generator<
  any,
  OfficialAllStylingInfo | undefined,
  AxiosResponse<LargeOfficialAllStylingResponse>
> {
  try {
    const response = yield call(ugcRequest.get, "/official/all-styling", {
      params: { ...payload }
    });
    return response.data.result[0];
  } catch (error) {
    return undefined;
  }
}
